import React, { useEffect, useState } from "react";

const DynamicIcons = ({ name, subPath }) => {
	const [logo, setLogo] = useState(null);

	useEffect(() => {
		const loadIcon = async () => {
			try {
				const svgIcon = await import(`./assets/${subPath}/${name}.svg`);
				setLogo(svgIcon.default);
			} catch (error) {
				try {
					const pngIcon = await import(`./assets/${subPath}/${name}.png`);
					setLogo(pngIcon.default);
				} catch (error) {
					console.error("Icon not found:", error);
				}
			}
		};

		loadIcon();
	}, [name, subPath]);

	if (!logo) {
		return null;
	}

	return (
		<img
			className={`lazyload ${name}`}
			src={logo}
			alt={name}
		/>
	);
};

export default DynamicIcons;
